import sk from "./sk.json";
import cz from "./cz.json";
import en from "./en.json";

export default {
  sk: sk,
  cz: cz,
  en: en,
};
